import axios from 'axios'
import qs from 'qs'
import router from '@/router'
import {
    Message,
    Loading,
    MessageBox
} from 'element-ui'

let lang = localStorage.getItem('lang') || 'en'
let querystring = location.search.slice(1)
if (querystring.includes('lang')) {
    lang = qs.parse(querystring)['lang']
}

let token = localStorage.getItem('token')
let auth = {}
if (token) {
    auth = {authorization: `bearer ${token}`} || {}
}
let xtimes = new Date().getTime()


const headers = Object.assign({
    'X-Requested-With': 'XMLHttpRequest',
    lang,
    xtimes
}, auth)

// 创建 axios 实例
const service = axios.create({
    baseURL: '/api/',
    timeout: 5000,
    headers
})

let loading = null

// 请求拦截器
service.interceptors.request.use(
    config => {
        // 剔除部分高频接口 主要是交易时的后台操作
        // if (!config.config || config.config.loading) {
        //     loading = Loading.service({
        //         lock: true,
        //         text: 'Loading',
        //         spinner: 'el-icon-loading',
        //         background: 'rgba(0, 0, 0, 0.5)'
        //     })
        // }
        return config
    },
    error => Promise.reject(error)
)

// 响应拦截器
service.interceptors.response.use(
    // res => res.data,
    response => {
        // 如果有加载的loading则关闭
        if (loading) loading.close()
        let {code, data, message} = response.data
        if (code === 500) {
            Message({
                type: 'error',
                duration: 3 * 1000,
                message: message
            })
            return Promise.reject(message)
        }
        if (code === 999) {
            Message({
                type: 'error',
                duration: 3 * 1000,
                message: 'login invalid, please log in again!'
            })
            localStorage.removeItem('token')
            localStorage.clear()
            router.push('/login')
            return Promise.reject(new Error([]))
        }
        return data
    },
    // error => Promise.reject(error)
    error => {
        if (loading) loading.close()
        let message
        if (error.message.includes('timeout')) {
            message = 'Connection timed out'
        } else {
            message = error.message
        }

        // msg
        Message({
            type: 'error',
            duration: 2 * 1000,
            message,
            callback() {
                throw new Error(error)
            }
        })
        return Promise.reject(error)
    }
)

export default service
